import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createTool, removeTool } from "./api";
import { invalidateAllQueries } from "utils/utils";
import { eventBus } from "utils/eventBus";

export function useRemoveTool(options = {}) {
    return useMutation({
        mutationFn: ({ id }) => removeTool(id),
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Removed tool Successfully");
            options.onSuccess?.();
        },
        onError: () => {
            toast.error("Error Removing tool");
        },
    });
}

export function useCreateTool({ casestudyId, ...options } = {}) {
    return useMutation({
        mutationFn: ({ item }) => createTool({ item }),
        onSuccess: (data) => {
            invalidateAllQueries();
            eventBus.emit("refresh:list", `case_studies_toolstools${casestudyId}`);
            toast.success("tool created");
            options.onSuccess?.(data);
        },
        onError: (err) => {
            toast.error("Error tool outcome");
            options.onError?.(err);
        },
    });
}